import axios from "axios";
import { getApiHost } from "../state/ducks/api";

export async function identifyUser(bearerToken) {
  const apiHost = await getApiHost();
  const response = await axios.get(`${apiHost}/api/caller-profile`, {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
    },
  });
  return { ...response.data, id: response.data.userId };
}

export async function getClientOrganizationName(bearerToken, clientId) {
  const apiHost = await getApiHost();
  const response = await axios.get(`${apiHost}/api/clients/${clientId}`, {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
    },
  });

  return await response.data.name;
}
